// extracted by mini-css-extract-plugin
export var center = "_y-2";
export var clickableRow = "_y-5";
export var expandedRow = "_y-7";
export var hoverable = "_y-4";
export var left = "_y-1";
export var right = "_y-3";
export var row = "_y-0";
export var selectedRow = "_y-6";
export var summaryRow = "_y-8";